<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm">
          <el-col>
            <el-form-item label="开始日期：">
              <el-date-picker size="medium" v-model="searchForm.START_DAY" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期：">
              <el-date-picker size="medium" v-model="searchForm.END_DAY" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)">筛选</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border style="margin-top: 20px" :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="PACKAGE_NAME" label="菜单"></el-table-column>
          <el-table-column prop="START_DAY" label="开始日期"></el-table-column>
          <el-table-column prop="END_DAY" label="结束日期"></el-table-column>
          <el-table-column prop="ORDER_STATUS" label="状态">
            <template slot-scope="scope">
              <span>{{ showStatus[scope.row.ORDER_STATUS] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="editRecipe(scope.row)" type="text">
                编辑菜单
              </el-button>
              <el-button @click="deleteMenu(scope.row)" type="text">
                删除
              </el-button>
              <el-button @click="transferOrder(scope.row)" type="text" v-if="scope.row.ORDER_STATUS == 0">
                转换订单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增/修改模态框 -->
    <el-dialog title="编辑" center :visible.sync="editFormVisible" width="420px">
      <el-form :model="editForm" ref="editForm" size="small" :inline="true" :label-width="formLableWidth">
        <el-form-item label="日期范围：">
          <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            v-model="editForm.GROUP_DAY" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: 230px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="菜单名称：">
          <el-input v-model="editForm.PACKAGE_NAME" style="width: 230px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryMealGroupFun, addMealGroupFun, delMealGroupFun, transferOrderFun,
} from 'api/packageManage';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      searchForm: {
      },
      editFormVisible: false,
      editForm: {},
      dkList: [],
      projects: [],
      customers: [],
      packageLists: [],
      formLableWidth: '120px',
      editFlag: 0,
      showStatus: ['未转订单', '已转订单'],
    };
  },
  created() {
    if (this.PACKAGE_SEARCH) {
      if ('DATA' in this.PACKAGE_SEARCH && 'CONDITION' in this.PACKAGE_SEARCH && 'CURRENT_PAGE' in this.PACKAGE_SEARCH) {
        this.searchForm = this.PACKAGE_SEARCH.CONDITION;
        this.currentPage = this.PACKAGE_SEARCH.CURRENT_PAGE;
        this.tableData = this.PACKAGE_SEARCH.DATA;
      }
    } else {
      this.queryData();
    }
  },
  computed: {
    PACKAGE_SEARCH() {
      return this.$store.state.PACKAGE_SEARCH;
    },
  },
  methods: {
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.START_DAY) {
        params.START_DAY = this.searchForm.START_DAY;
      }
      if (this.searchForm.END_DAY) {
        params.END_DAY = this.searchForm.END_DAY;
      }
      queryMealGroupFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].OP_ROLE;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_PACKAGE_SEARCH', {
            DATA: this.tableData,
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    openAdd() {
      this.editFormVisible = true;
      this.editFlag = 0;
    },
    openEdit(row) {
      this.editFormVisible = true;
      this.editFlag = 1;
      this.editForm = row;
    },
    submitAdd() {
      if (!this.editForm.PACKAGE_NAME) {
        this.$message.show({ text: '请输入菜单名称', type: 'warning' });
        return false;
      }
      const params = {
        PACKAGE_NAME: this.editForm.PACKAGE_NAME,
      };
      if (this.editForm.GROUP_DAY) {
        params.START_DAY = this.editForm.GROUP_DAY[0];
        params.END_DAY = this.editForm.GROUP_DAY[1];
      } else {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      if (this.editFlag == 0) {
        addMealGroupFun(params).then((result) => {
          this.$message.show({ text: '新增成功', type: 'success' });
          this.editForm = {};
          this.queryData();
          this.editFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        params.ID = this.editForm.ID;
        // eslint-disable-next-line no-undef
        editMenuFun(params).then((result) => {
          this.$message.show({ text: '新增成功', type: 'success' });
          this.editForm = {};
          this.queryData();
          this.editFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    deleteMenu(row) {
      this.$confirm('确认删除该菜单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ID: row.ID,
        };
        delMealGroupFun(params).then((res) => {
          this.queryData();
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
    },
    editRecipe(row) {
      this.$router.push({ name: 'editRecipe' });
      sessionStorage.setItem('mealGroupId', row.ID);
    },
    transferOrder(row) {
      const params = {
        PACKAGE_ID: row.ID,
      };
      transferOrderFun(params).then((res) => {
        this.queryData();
        this.$message.show({ text: '转换成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/mealGroup.vue